import { users } from "./users"

export const getLoginUrl = () => {
  return "api"
  // return "http://localhost:8080/docs/api"
}

export const isBrowser = () => typeof window !== "undefined"
export const getUser = () => {
    const user = isBrowser() && window.localStorage.getItem("gatsbyUser")
        ? JSON.parse(window.localStorage.getItem("gatsbyUser"))
        : null
    if (user==null || !user.login) return null; else return user;

}
const setUser = user => {
    isBrowser() && window.localStorage.setItem("gatsbyUser", JSON.stringify(user))
    return user
}
export const handleLogin = async ({ username, password }) => {
  console.log("Environnement", process.env.NODE_ENV)
  if(process.env.NODE_ENV === "development") return setUser({ login: "ADMIN", firstname: "ADMIN", lastname: "ADMIN", tenant: { id: "x", subdomain: "x", onpremises: true} })
  const headers = new Headers()
  headers.append("Content-Type", "application/json");
  const response = await fetch(new Request(getLoginUrl() + "/users/login", {
    method: 'POST',
    headers,
    body: JSON.stringify({
      login: username,
      password: password
    })
  }))
  const responseStatus = response.status
  const responseContentType = response.headers.get("content-type")
  if (response.status === 200 && responseContentType && responseContentType.indexOf("application/json") !== -1) {
    const json = await response.json()
    console.log("Login succes")
    return setUser(json)
  } else {
    console.log("Echec authentification", response)
    return false
  }

}

export const handleLoginRaw = async ({ username, password }) => {
    const found = users.find(it => {
        return it.login === username && it.login === password
    })
    if (found !== undefined){
        console.log("Login succes")
        return setUser(found)
    } else
        return false
}
export const isLoggedIn = () => {
    const user = getUser()
    return user!=null
}
export const logout = callback => {
    setUser({})
    callback()
}
